export const HOTEL = {
  name: "Hotel Azulo Inn",
  short: "Azulo",
  brand: "Azulo Hotels",
  group: "Marwon Group",
  founded: 1980,
  positioning: "New-age boutique luxury in the heart of Delhi",
  location: "Safdarjung Enclave · New Delhi",
  city: "New Delhi",
  phone: "011-42603179",
  mobile: "+91-98100-98269",
  whatsapp: "919810098269",
  email: "reservation@azulohotels.com",
  careersEmail: "careers@azulohotels.com",
  partnershipsEmail: "partnerships@azulohotels.com",
  address: "B1/16, Safdarjung Enclave, Near Bhikaji Cama Place, New Delhi, Delhi 110029",
  established: "Hotel Azulo Inn",
  tagline: "New-age boutique luxury in the heart of Delhi.",
  rooms_count: 14,
  logo: "/images/033084917fee.webp",
  // Guest-photographed interiors
  images: {
    // New brand exterior + garden + rooms
    exterior: "/images/884020648570.webp",
    garden: "/images/fa3e6abdca37.webp",
    roomA: "/images/8527636a6e1a.webp",
    roomB: "/images/231a38e90872.webp",
    img1: "/images/31bdfd4ef342.webp",
    img2: "/images/19ec8379925f.webp",
    img3: "/images/c6d7852b2c9f.webp",
    img4: "/images/421489157e47.webp",
    img5: "/images/4c3b59306918.webp",
    img6: "/images/7b630d09ab53.webp",
    img7: "/images/bf8b959ae988.webp",
    img8: "/images/d5719cd52c07.webp",
    img9: "/images/725c64eddb3c.webp",
    img10: "/images/c976bb2db03a.webp",
    img11: "/images/b0a5f88f14dd.webp",
    img12: "/images/f4dd8d7ffad0.webp",
    img13: "/images/a6fa2c7f94b5.webp",
  },
};

HOTEL.heroImage = HOTEL.images.exterior;

// Grouped, curated by category for the Gallery page
HOTEL.galleryGroups = [
  {
    id: "exteriors",
    eyebrow: "The Property",
    title: "Exteriors & Garden",
    blurb:
      "Sun-washed white façade on a quiet residential lane, with a leafy lawn at the back.",
    images: [HOTEL.images.exterior, HOTEL.images.garden],
  },
  {
    id: "rooms",
    eyebrow: "The Stay",
    title: "Rooms",
    blurb:
      "Fourteen warmly lit rooms. Crisp linens, dark wood floors, considered lighting.",
    images: [
      HOTEL.images.img1,
      HOTEL.images.img7,
      HOTEL.images.img6,
      HOTEL.images.img3,
      HOTEL.images.img4,
      HOTEL.images.img9,
      HOTEL.images.img5,
      HOTEL.images.img10,
    ],
  },
  {
    id: "bathrooms",
    eyebrow: "The Details",
    title: "Bathrooms",
    blurb:
      "Bright tilework, walk-in glass showers, and modern fittings in every room.",
    images: [HOTEL.images.img12, HOTEL.images.img13, HOTEL.images.img11],
  },
];

HOTEL.gallery = HOTEL.galleryGroups.flatMap((g) => g.images);

export const EXPERIENCES = [
  {
    title: "The Restaurant",
    kind: "Dining",
    blurb:
      "A warm in-house restaurant for unhurried breakfasts and considered dinners — North Indian, Continental, and Pan-Asian, prepared from the morning's market.",
  },
  {
    title: "The Garden Lawn",
    kind: "Outdoor",
    blurb:
      "A lush green lawn at the back of the property — the right place for an evening stroll, a slow chai, or a quiet conversation under the trees.",
  },
  {
    title: "Concierge & Transport",
    kind: "Service",
    blurb:
      "Cars, drivers, and itineraries arranged on request. Hassle-free parking on premises. Our front desk is always reachable, day or night.",
  },
  {
    title: "Workspace & Connectivity",
    kind: "Stay",
    blurb:
      "High-speed Wi-Fi across the property, in-room workstations, and quiet rooms — built around guests on business in Bhikaji Cama Place and beyond.",
  },
];

export const NEARBY = [
  { name: "Bhikaji Cama Place Metro", distance: "1.1 km", note: "Closest metro" },
  { name: "Deer Park", distance: "2.2 km", note: "Hauz Khas" },
  { name: "Qutub Minar", distance: "6.2 km", note: "UNESCO World Heritage" },
  { name: "Buddha Jayanti Park", distance: "7.8 km", note: "Quiet ridge gardens" },
  { name: "IGI Airport", distance: "9 km", note: "Terminal 3 / 1" },
  { name: "New Delhi Railway Station", distance: "11.8 km", note: "Mainline" },
  { name: "Tughlakabad Fort", distance: "13 km", note: "14th century" },
];

export const TESTIMONIALS = [
  {
    quote:
      "Calm, considered, and always quiet — exactly the kind of address you want in central Delhi.",
    author: "A returning guest",
  },
  {
    quote:
      "The team are warm, the rooms are spotless, and the lawn is a small miracle in the city.",
    author: "TripAdvisor review",
  },
];
